import { Link } from "react-router-dom/cjs/react-router-dom.min";

export default function Home() {
  const categoryList = [
    {
      title: "صفحه نخست",
      to: "/all",
      image: "/img/home.png",
    },
    {
      title: "امت نیوز",
      to: "/news",
      image: "/img/unews.png",
    },
    {
      title: "امت ویدیو",
      to: "/video",
      image: "/img/video.png",
    },
    {
      title: "امت آدیو",
      to: "/audio",
      image: "/img/audio.png",
    },
    {
      title: "امت کتاب",
      to: "/book",
      image: "/img/books.png",
    },
    {
      title: "امت مجله",
      to: "/magazine",
      image: "/img/magzine.png",
    },
    {
      title: "بوکلت",
      to: "/booklet",
      image: "/img/booklet.png",
    },
    {
      title: "مینی بوک",
      to: "/minibook",
      image: "/img/minibook.png",
    },
  ];

  return (
    <div className="bg-body min-vh-100 align-items-center ">
      <div
        className="py-3 text-body max-container-width mx-auto"
        style={{ position: "relative", top: "4em" }}
      >
        <div
          className="d-flex flex-wrap justify-content-center align-items-center gap-4 rounded-4 shadow-sm"
          style={{
            padding: "7em 4em",
            border: "3px dashed #0870a9",
          }}
        >
          <Link
            to="/"
            style={{
              position: "absolute",
              top: "-3em",
              left: "0",
              right: "0",
              marginInline: "auto",
              width: "fit-content",
              padding: "1em",
              backgroundColor: "white",
            }}
          >
            <img
              src="/img/logo-full.png"
              alt="Ummat Production"
              style={{ maxHeight: "8em" }}
            />
          </Link>
          {categoryList.map((category, index) => (
            <Link
              key={index}
              to={category.to}
              className="text-decoration-none text-body home-buttons"
            >
              <img src={category.image} alt={category.title} />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
